import axios from 'axios'
import { ExportRequest, ExportResponse, RandomRateconfResponse, StatsResponse, ValidationRequest, ValidationResponse } from './types'

const rateconFineTuningApi = {
    getRandomRateconf: async (): Promise<RandomRateconfResponse> => {
        const response = await axios.get<RandomRateconfResponse>('/gluon/ratecon-fine-tuning/random')
        return response.data
    },

    validateRateconf: async (request: ValidationRequest): Promise<ValidationResponse> => {
        const response = await axios.post<ValidationResponse>('/gluon/ratecon-fine-tuning/validate', request)
        return response.data
    },

    getStats: async (): Promise<StatsResponse> => {
        const response = await axios.get<StatsResponse>('/gluon/ratecon-fine-tuning/stats')
        return response.data
    },

    exportLabels: async (request: ExportRequest): Promise<ExportResponse> => {
        const response = await axios.post<ExportResponse>('/gluon/ratecon-fine-tuning/export', request)
        return response.data
    },
}

export default rateconFineTuningApi
